export default __webpack_public_path__ + "static/media/test5.11044791.png";